import { Injectable } from '@angular/core';
import { CustomInputsComponent } from '../../../modules/signature/custom-inputs/custom-inputs.component';
import { IvSignComponent } from '../../../modules/signature/ivsign/ivsign.component';
import { OtpSignerComponent } from '../../../modules/signature/otpsigner/otpsigner.component';
import { SimpleSignerComponent } from '../../../modules/signature/simplesigner/simplesigner.component';

@Injectable()
export class LoadSigTypeService {
  constructor() { }
  getComponents() {
    return {
      SIG: IvSignComponent,
      SIGQSCD: IvSignComponent,
      RVDOTP: OtpSignerComponent,
      SIGOTP: OtpSignerComponent,
      SIMPLE: SimpleSignerComponent,
      VAL: '',
      FORM: CustomInputsComponent
    };
  }

}
